import BaseApiService from './BaseApiService.js';

class LibraryService extends BaseApiService {
  // --- Settings Operations ---
  async getLibrarySettings() {
    const res = await this.makeRequest('/api/admin/library/settings');
    if (res && res.success) {
      return res.data;
    }
    return null;
  }

  async saveLibrarySettings(settingsData) {
    return this.makeRequest('/api/admin/library/settings', {
      method: 'POST',
      body: JSON.stringify(settingsData)
    });
  }

  // --- Books & Physical Copies Operations ---
  async listBooks() {
    const res = await this.makeRequest('/api/admin/library/books');
    if (res && res.success) {
      return res.data || [];
    }
    return [];
  }

  async getCopiesForBook(bookId) {
    const res = await this.makeRequest(`/api/admin/library/copies/${bookId}`);
    if (res && res.success) {
      return res.data || [];
    }
    return [];
  }

  async getCopyByAccession(accessionNo) {
    return this.makeRequest(`/api/admin/library/accession/${accessionNo}`);
  }

  async createBook(bookData) {
    return this.makeRequest('/api/admin/library/books', {
      method: 'POST',
      body: JSON.stringify(bookData)
    });
  }

  async updateBook(bookId, bookData) {
    return this.makeRequest(`/api/admin/library/books/${bookId}`, {
      method: 'PUT',
      body: JSON.stringify(bookData)
    });
  }

  async deleteBook(bookId) {
    return this.makeRequest(`/api/admin/library/books/${bookId}`, {
      method: 'DELETE'
    });
  }

  async clearAllBooks() {
    return this.makeRequest('/api/admin/library/clear-all', {
      method: 'DELETE'
    });
  }

  // --- Borrow Issues, Returns, Renewals & Fines ---
  async listIssues() {
    const res = await this.makeRequest('/api/admin/library/issues');
    if (res && res.success) {
      return res.data || [];
    }
    return [];
  }

  async issueBook(issueData) {
    return this.makeRequest('/api/admin/library/issue', {
      method: 'POST',
      body: JSON.stringify(issueData)
    });
  }

  async returnBook(issueId, condition = 'GOOD') {
    return this.makeRequest(`/api/admin/library/return/${issueId}?condition=${encodeURIComponent(condition)}`, {
      method: 'POST'
    });
  }

  async renewBook(issueId) {
    return this.makeRequest(`/api/admin/library/renew/${issueId}`, {
      method: 'POST'
    });
  }

  async payFine(issueId, amount) {
    return this.makeRequest(`/api/admin/library/pay-fine/${issueId}?amount=${encodeURIComponent(amount)}`, {
      method: 'POST'
    });
  }

  async getLibraryStats() {
    const res = await this.makeRequest('/api/admin/library/stats');
    if (res && res.success) {
      return res.data || { totalBooks: 0, totalCopies: 0, availableCopies: 0, issuedCopies: 0, overdueCopies: 0 };
    }
    return { totalBooks: 0, totalCopies: 0, availableCopies: 0, issuedCopies: 0, overdueCopies: 0 };
  }
}

const libraryService = new LibraryService();
export default libraryService;
